var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBlockSizeIcon = function SvgBlockSizeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1 0 4v7l7.5 4 7.5-4V4zM7 13.6l-6-3.2V5.533l6 3.2zM1.297 4.558 7.5 2.077l6.203 2.481L7.5 7.866z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlockSizeIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;